import type { CrewListDraft, CrewListSource, CrewLists, CrewListView } from '@felix/ui';
import { api } from './api.js';

/**
 * Crew ▸ Crew Lists (IMO FAL Form 5; ADR 0130 §B): ofis API'si. Ofis gemi seçer; ofisin listesi
 * yalnız bulutta kalır, gemiye inmez. PDF tarayıcıda (`browserPdfOutput`).
 */
const BASE = '/office/crew/lists';
const withVessel = (path: string, vesselId?: string | null) =>
  vesselId ? `${path}?vesselId=${encodeURIComponent(vesselId)}` : path;

export const officeCrewListSource: CrewListSource = {
  scope: 'office',
  list: (vesselId) => api<CrewLists>(withVessel(BASE, vesselId)),
  draft: (vesselId) => api<CrewListDraft>(withVessel(`${BASE}/draft`, vesselId)),
  detail: (id) => api<CrewListView>(`${BASE}/${encodeURIComponent(id)}`),
  create: (vesselId, list) => api<CrewListView>(BASE, { method: 'POST', body: { vesselId, list } }),
};
